export default "__VITE_ASSET__BMMcF6d$__"